const common = require('./common');

module.exports = {
  ...common,
  INTERNAL_API_URL: 'https://app.izzyconstat.fr/internal-api',
  LOG_ROCKET_APP_ID: 'dm4e7l/izzyconstat',
};
